import classnames from 'classnames'
import PropTypes from 'prop-types'

import HelpCenterLink from './user_menu/HelpCenterLink'

import {
  useOrganizationCobranding
} from '../../../shared_components/OrganizationCobrandingContext'

import OrganizationCobrandingHeaderLogo from '../../../shared_components/header/OrganizationCobrandingHeaderLogo'
import SecurityInfoLink from './user_menu/SecurityInfoLink'
import Logo from '../../../shared_components/Logo'
import UserMenu from './user_menu/UserMenu'
import SearchContainer from './corp_max/search/SearchContainer'
import {hasOrganizationCobranding} from '../../../lib/cobrandingTools'

import './headerBar.scss'

export const HeaderBar = ({displayBanner, hideSearch}) => {
  const organizationCobranding = useOrganizationCobranding()

  return (
    <header className={classnames('header-bar', displayBanner)}>
      {hasOrganizationCobranding(organizationCobranding) ?
        <OrganizationCobrandingHeaderLogo
          includeEverplansLogo={true}
          organizationCobranding={organizationCobranding}
        /> :
        <a href='#/cm/dashboard'><Logo /></a>}
      <div className='header-bar-nav flex-container'>
        {!hideSearch && <SearchContainer />}
        <SecurityInfoLink />
        <HelpCenterLink />
        <UserMenu />
      </div>
    </header>
  )
}

HeaderBar.propTypes = {
  displayBanner: PropTypes.string,
  hideSearch: PropTypes.bool
}

export default HeaderBar
